import React, { Component } from "react";
import PropTypes from "prop-types";
import SearchMenu from "./SearchMenu";

import { Item } from "@zendeskgarden/react-menus";

import gql from "graphql-tag";
import { Query } from "react-apollo";

const labelsQuery = gql`
  query Labels($name: String) {
    labels(query: { name: $name }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export default class LabelMenu extends Component {
  static propTypes = {
    getItemProps: PropTypes.func.isRequired,
    focusedKey: PropTypes.string,
  };

  state = { searchText: "" };

  onSearchTextChanged = searchText => {
    this.setState({ searchText });
  };

  render() {
    const { searchText } = this.state;
    const { getItemProps, focusedKey } = this.props;

    return (
      <SearchMenu>
        <SearchMenu.Input onChange={this.onSearchTextChanged} />
        <Query
          query={labelsQuery}
          variables={{
            name: searchText,
          }}
        >
          {({ loading, error, data }) => {
            if (error) return <SearchMenu.SearchFailure />;

            const { labels = { edges: [], total: 0 } } = data;

            return (
              <SearchMenu.Items>
                {labels.edges.map(({ node: { id, name } }) => (
                  <Item
                    {...getItemProps({
                      key: `label-${id}`,
                      focused: focusedKey === `label-${id}`,
                    })}
                    data-test-id={`filter-menu-label-item-${id}`}
                  >
                    {name}
                  </Item>
                ))}
              </SearchMenu.Items>
            );
          }}
        </Query>
      </SearchMenu>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/LabelMenu.js